import React, { useEffect, useRef, useState } from "react";

import PageTransition from "./page-transition";
import NavigationMenu from "./navigation";
import Target from "./Cursor/target";

import LogoSvg from '../svgs/logo.svg';
import '../styles/header.scss';
import { EVENTS } from "../helpers/globals";
import gsap from "gsap";

const NavIcon = ({ isOpen = false, ...rest }) => (
  <div className={`${isOpen ? 'navicon-isopen ' : ''}navicon-container`} role="button" {...rest}>
    <span className="navicon-top" />
    <span className="navicon-bottom" />
  </div>
)

const Header: React.FC<any> = () => {

  const isTop = useRef(false);
  const offsetY = useRef(0);

  const [state, setState] = useState({
    initial: false,
    clicked: null
  });
  const [disabled, setDisabled] = useState(false);

  const myRef = useRef({
    location: null,
  });

  useEffect(() => {
    window.addEventListener(EVENTS.onPageScroll, (e) => {
      if (e?.detail?.offset) {
        offsetY.current = e.detail.offset.y;
        toggleLogo();
      }
    });

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener(EVENTS.onPageScroll, () => {});
      }
    }
  }, []);

  const toggleLogo = (force = false) => {
    if (force || (offsetY.current <= 50 && !isTop.current)) {
      isTop.current = true;
      showLogoAnim(1);
    } else if (offsetY.current > 50 && isTop.current) {
      isTop.current = false;
      showLogoAnim(0);
    }
  }

  const showLogoAnim = (to) => {
      gsap.to('.logoContainer', {
        opacity: to,
        duration: 0.4,
        ease: "power3.inOut"
      })
  }

  const onNavToggle = () => {
    if (disabled) {
      return;
    }

    disableMenu();
    if (state.initial === false) {
      toggleLogo(true);
      setState({
        initial: null,
        clicked: true
      })
    } else if (state.clicked === true) {
      toggleLogo(!state.clicked);
      setState({
        initial: null,
        clicked: !state.clicked
      })
    } else if (state.clicked === false) {
      toggleLogo(!state.clicked);
      setState({
        initial: null,
        clicked: !state.clicked
      })
    }
  }

  const disableMenu = () => {
    setDisabled(!disabled);

    setTimeout(() => {
      setDisabled(false);
    }, 1200);
  }

  const onCloseMenu = () => {
    setState({
      initial: null,
      clicked: !state.clicked,
    })
  }

  return (
    <header>
      <Target className={`${state.clicked ? 'logoContainer-isopen ' : ''}logoContainer`}>
        <PageTransition to="/">
          <LogoSvg style={{ color: state.clicked ? "white" : "black" }} />
        </PageTransition>
      </Target>
      <Target>
        <NavIcon onClick={onNavToggle} isOpen={state.clicked} />
      </Target>
      
      <NavigationMenu state={state} closeMenu={onCloseMenu} />
    </header>
  );
};

export default Header;